import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { CalendarSharedComponent } from './calendar.component';

import { RadioSharedModule } from '../../atoms/radio/radio.module';
import { SlotSharedModule } from '../../molecules/slot/slot.module';
import { TextNavSharedModule } from '../../molecules/text.nav/text.nav.module';
import { TextSliderSharedModule } from '../../molecules/text.slider/text.slider.module';
import { IconSharedModule } from '../../atoms/icon/icon.module';

import { TransformDateNthModule } from '../../../shared/pipe/dateNth/pipe.dateNth.module';

@NgModule({
    declarations: [
        CalendarSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        SlotSharedModule,
        RadioSharedModule,
        TextNavSharedModule,
        TransformDateNthModule,
        TextSliderSharedModule,
        IconSharedModule,
    ],
    exports: [
        CalendarSharedComponent
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class CalendarSharedModule {}
